<template>
    <div :ref="isRoot ? 'scrollContainer' : null" :id="isRoot ? 'scrollContainer' : null" class="relative z-10"
        :class="{ 'cursor-grab': isRoot && !isDragging, 'cursor-grabbing': isRoot && isDragging, 'select-none': isDragging }"
        @mousedown="isRoot && startDragging($event)" @mousemove="isRoot && onDragging($event)"
        @mouseup="isRoot && stopDragging()" @mouseleave="isRoot && stopDragging()"
        @wheel="isRoot && handleWheel($event)">
        <div class="">


            <div v-if="isRoot"
                class="overflow-auto customScrollbar customHorizontalScrollbar bg-white rounded-[12px] border border-[#E5E7EB] px-[2rem] py-[1rem] 2xl:px-[2rem] 2xl:py-[2rem] w-full"
                :style="{ maxHeight: dynamicHeight, minHeight: dynamicHeight }">
                <div class=" gap-6 items-start w-full min-w-max"
                    :style="{ transform: `scale(${zoomLevel})`, transformOrigin: 'top left' }">
                    <!-- Main Content (Root Node) -->
                    <div>
                        <div
                            class="relative flex items-center gap-[10px] pb-[10px] mb-[10px] border-b border-[#efefef] z-30">

                            <!-- Expand Button -->
                            <div class="relative group">
                                <button @click="expandAll()"
                                    class="flex items-center justify-center rounded-full text-[23px] w-[24px] h-[24px] text-[#fff] bg-[#BA90C6]">
                                    <span class="leading-[0] relative top-[0px] -left-[0.5px]">+</span>
                                </button>

                                <div class="absolute left-[30px] -translate-x-1/2 top-[30px] whitespace-nowrap
                opacity-0 group-hover:!opacity-100 transition-opacity
                text-[12px] bg-[#333] text-white px-[8px] py-[4px] rounded shadow-md">
                                    Expand All levels
                                </div>
                            </div>

                            <!-- Collapse Button -->
                            <div class="relative group">
                                <button @click="collapseAll()"
                                    class="flex items-center justify-center rounded-full text-[23px] w-[24px] h-[24px] text-[#fff] bg-[#BA90C6]">
                                    <span class="leading-[0] relative -top-[1px] -left-[0.5px]">-</span>
                                </button>

                                <div class="absolute left-1/2 -translate-x-1/2 top-[30px] whitespace-nowrap
                opacity-0 group-hover:!opacity-100 transition-opacity
                text-[12px] bg-[#333] text-white px-[8px] py-[4px] rounded shadow-md">
                                    Collapse All levels
                                </div>
                            </div>

                            <div class="h-6 w-[1px] bg-gray-200 mx-2"></div>

                            <!-- Zoom Out -->
                            <div class="relative group">
                                <button @click="zoomOut()"
                                    class="flex items-center justify-center rounded-full w-[30px] h-[30px] border border-[#BA90C6] text-[#BA90C6] bg-white hover:bg-[#BA90C6] hover:text-white transition-colors">
                                    <span class="leading-[0] text-[20px]">-</span>
                                </button>
                                <div
                                    class="absolute left-1/2 -translate-x-1/2 top-[35px] whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity text-[12px] bg-[#333] text-white px-2 py-1 rounded shadow-md z-[100]">
                                    Zoom Out
                                </div>
                            </div>

                            <!-- Zoom Percentage -->
                            <div @click="resetZoom()"
                                class="cursor-pointer font-roboto font-bold text-[#BA90C6] text-[14px] min-w-[50px] text-center"
                                title="Reset Zoom">
                                {{ Math.round(zoomLevel * 100) }}%
                            </div>

                            <!-- Zoom In -->
                            <div class="relative group">
                                <button @click="zoomIn()"
                                    class="flex items-center justify-center rounded-full w-[30px] h-[30px] border border-[#BA90C6] text-[#BA90C6] bg-white hover:bg-[#BA90C6] hover:text-white transition-colors">
                                    <span class="leading-[0] text-[20px]">+</span>
                                </button>
                                <div
                                    class="absolute left-1/2 -translate-x-1/2 top-[35px] whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity text-[12px] bg-[#333] text-white px-2 py-1 rounded shadow-md z-[100]">
                                    Zoom In
                                </div>
                            </div>

                        </div>
                        <div v-for="rootNode in localTreeData" :key="rootNode.id" class="relative block w-full">

                            <!-- Deep Vertical Drop Line for Root's Children -->
                            <div class="absolute border-l-[1.5px] border-dashed border-[#CBD5E1] transition-opacity duration-500 pointer-events-none z-0"
                                :style="{ opacity: (rootNode.expanded && rootNode.children && rootNode.children.length > 0) ? 1 : 0, left: '10px', top: '55px', bottom: '0px', height: '70px' }">
                            </div>

                            <!-- Root Header -->
                            <div class="flex items-center ml-[50px] p-4 relative min-h-[70px] 2xl:min-h-[100px] z-10 bg-white border border-[#efefef] min-w-[350px]"
                                style="margin-right: 0;">

                                <!-- Root Toggle Button -->
                                <button v-if="rootNode.children && rootNode.children.length"
                                    @click="rootNode.expanded = !rootNode.expanded"
                                    class="absolute z-20 w-[24px] h-[24px] bg-white border border-[#7286D3] text-[#7286D3] rounded-full flex items-center justify-center font-medium text-[22px] leading-[0]"
                                    style="left: -50px; top: 50%; transform: translateY(-50%);">
                                    <!-- <span style="margin-top: 1px;">{{ rootNode.expanded ? '-' : '+' }}</span> -->
                                    <span v-if="rootNode.expanded" style="margin-top: -3px;">-</span>
                                    <span v-else style="margin-top: 1px;">+</span>
                                </button>

                                <!-- Root Horizontal dashed branch -->
                                <div v-if="rootNode.children && rootNode.children.length"
                                    class="absolute border-t-[1.5px] border-dashed border-[#CBD5E1] z-10"
                                    style="left: -25px; width: 16px; top: 50%;"></div>

                                <!-- Root Solid Dot -->
                                <div class="absolute w-[8px] h-[8px] rounded-full bg-[#BAC1CB] z-20"
                                    style="left: 0; top: 50%; transform: translate(-50%, -50%);"></div>

                                <!-- Main Root Avatar and Info -->
                                <div class="flex flex-1 items-center">
                                    <img :src="rootNode.avatar || require('../../assets/images/default-user.svg')"
                                        class="w-[50px] h-[50px] 2xl:w-[70px] 2xl:h-[70px] rounded-full object-cover shadow-[0_4px_10px_0_rgba(0,0,0,0.1)]" />
                                    <div class="ml-4 flex-1">
                                        <h3
                                            class="text-[18px] 2xl:text-[22px] font-bold font-roboto text-[#333] leading-tight">
                                            {{ rootNode.name || 'Mark Steven' }}</h3>
                                        <div class="text-[13px] 2xl:text-[14px] font-roboto text-[#999]">
                                            {{ rootNode.role || 'Standard Affiliate' }}
                                            <span v-if="rootNode.subRole">| <span class="text-[#8479E1]">{{
                                                rootNode.subRole
                                                    }}</span></span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Root Stats Area -->
                                <div class="flex items-center justify-end gap-[20px] shrink-0">
                                    <div class="text-left w-[80px]">
                                        <div class="text-[22px] font-roboto font-bold leading-tight text-[#333]">{{
                                            rootNode.levelCount || '0'
                                            }}</div>
                                        <div class="text-[14px] font-roboto text-[#999]">Level</div>
                                    </div>
                                    <div class="text-right min-w-[100px]">
                                        <div class="text-[22px] font-roboto font-bold leading-tight text-[#333]">{{
                                            rootNode.earning ||
                                            '$0.00' }}</div>
                                        <div class="text-[14px] font-roboto text-[#999]">Commission</div>
                                    </div>
                                </div>
                            </div>

                            <!-- Root Children Container -->
                            <transition name="tree">
                                <div v-if="rootNode.expanded" class="tree-container is-root-container block w-full">
                                    <div class="tree-container-content">
                                        <div class="relative pb-4">
                                            <tree-page v-for="(child, i) in rootNode.children" :key="child.id"
                                                :node="child" :is-root="false"
                                                :is-last="i === rootNode.children.length - 1" :depth="1" />
                                        </div>
                                    </div>
                                </div>
                            </transition>

                        </div>
                    </div>
                </div>
            </div>

            <!-- Recursive Child Node -->
            <div v-if="!isRoot" class="relative child-node-row group block w-full">

                <!-- Vertical drop segment for THIS row from PARENT -->
                <div class="absolute border-l-[1.5px] border-dashed border-[#CBD5E1] z-10"
                    :style="{ left: ((depth - 1) * 40 + 10) + 'px', top: '5px', height: isLast ? '30px' : '100%' }">
                </div>

                <div class="flex items-center relative w-full">

                    <template v-if="node.children && node.children.length">
                        <!-- Horiz Line 1: Parent drop to Child Toggle -->
                        <div class="absolute border-t-[1.5px] border-dashed border-[#CBD5E1] z-10"
                            :style="{ left: ((depth - 1) * 40 + 10) + 'px', width: '90px', top: '38px' }"></div>

                        <!-- Child Toggle Button -->
                        <button @click="node.expanded = !node.expanded"
                            class="absolute z-20 w-[24px] h-[24px] bg-white border border-[#7286D3] text-[#7286D3] rounded-full flex items-center justify-center font-medium text-[22px] leading-[0]"
                            :style="{ left: (depth * 40 + 12) + 'px', top: '38px', transform: 'translate(-50%, -50%)' }">
                            <span v-if="node.expanded" style="margin-top: -3px;">-</span>
                            <span v-else style="margin-top: 1px;">+</span>
                        </button>

                        <!-- Toggle vertical drop to ITS children -->
                        <div class="absolute border-l-[1.5px] border-dashed border-[#CBD5E1] transition-opacity duration-500 pointer-events-none z-10"
                            :style="{ opacity: node.expanded ? 1 : 0, left: (depth * 40 + 10) + 'px', top: '40px', bottom: '-5px' }">
                        </div>

                        <!-- Horiz Line 2: Child Toggle to Dot -->
                        <div class="absolute border-t-[1.5px] border-dashed border-[#CBD5E1] z-10"
                            :style="{ left: (depth * 40 + 10) + 'px', width: '10px', top: '38px' }"></div>
                    </template>

                    <template v-else>
                        <!-- Horiz Line Full: Parent drop straight to Dot -->
                        <div class="absolute border-t-[1.5px] border-dashed border-[#CBD5E1] z-10"
                            :style="{ left: ((depth - 1) * 40 + 10) + 'px', width: '90px', top: '38px' }"></div>
                    </template>

                    <!-- Solid Gray Alignment Dot -->
                    <div class="absolute w-[8px] h-[8px] rounded-full bg-[#BAC1CB] z-20"
                        :style="{ left: (depth * 40 + 60) + 'px', top: '38px', transform: 'translate(-50%, -50%)' }">
                    </div>

                    <div class="flex items-center gap-[15px] p-[15px] flex-1 border border-[#efefef] min-w-[450px]"
                        :style="{ marginLeft: (depth * 40 + 60) + 'px' }">
                        <!-- Avatar & Name -->
                        <div class="flex items-center flex-1 min-w-0">
                            <img :src="node.avatar || require('../../assets/images/default-user.svg')"
                                class="w-[40px] h-[40px] rounded-full object-cover pointer-events-none" />
                            <div class="ml-3 flex flex-col justify-center">
                                <div class="font-normal font-roboto text-[16px] text-[#333] leading-tight truncate">
                                    {{ node.name || 'Child Affiliate' }}
                                </div>
                                <div class="text-[12px] text-[#999] truncate">{{ node.role || 'Standard Affiliate' }}
                                    <span v-if="node.subRole" class="text-[#3B82F6]">| {{ node.subRole }}</span></div>
                            </div>
                        </div>

                        <div class="flex items-center justify-end gap-[20px] shrink-0">
                            <!-- Level count -->
                            <div class="w-[80px] text-left">
                                <div class="text-[16px] font-roboto font-bold text-[#333]">{{ node.levelCount || '0' }}
                                </div>
                                <div class="text-[12px] font-roboto font-normal text-[#999]">Level</div>
                            </div>

                            <!-- Earning Amount -->
                            <div class="min-w-[100px] text-[16px] font-bold text-[#333] text-right">
                                {{ node.earning || '$0.00' }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Recursive Call for Nested Branches -->
                <transition name="tree">
                    <div v-if="node.expanded" class="tree-container block w-full">
                        <div class="tree-container-content">
                            <div class="relative">
                                <tree-page v-for="(child, idx) in node.children" :key="child.id" :node="child"
                                    :is-root="false" :is-last="idx === node.children.length - 1" :depth="depth + 1" />
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
import staticTreeData from './tree.json';
import { mapActions, mapGetters } from "vuex";

export default {
    name: 'tree-page', // Allows self-recursion in Vue
    props: {
        isRoot: {
            type: Boolean,
            default: true
        },
        node: {
            type: Object,
            default: () => ({})
        },
        isLast: {
            type: Boolean,
            default: false
        },
        depth: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            loading: true,
            isCallingApi: false,
            localTreeData: [],
            selectedItem: {
                id: this.$route.params.id
            },
            dynamicHeight: '100vh',
            isDragging: false,
            startX: 0,
            startY: 0,
            scrollLeft: 0,
            scrollTop: 0,
            zoomLevel: 1,
        }
    },
    computed: {
        ...mapGetters([
            "networkAffiliateDataResponse",
        ]),
    },
    mounted() {
        if (this.isRoot && this.loading) {
            this.networkAffiliateData()
        }
        if (this.isRoot) {
            this.calculateHeight();
            window.addEventListener('resize', this.calculateHeight);
        }
    },
    beforeUnmount() {
        if (this.isRoot) {
            window.removeEventListener('resize', this.calculateHeight);
        }
    },
    watch: {
        networkAffiliateDataResponse: function (data) {
            this.loading = false
            this.scrollToTop();
            this.localTreeData = this.networkAffiliateDataResponse.body
        },
    },
    methods: {
        ...mapActions([
            "networkAffiliateData",
        ]),
        calculateHeight() {
            this.$nextTick(() => {
                const container = this.$refs.scrollContainer;
                if (container) {
                    const rect = container.getBoundingClientRect();
                    // dynamically factor out footer height so the main browser window doesn't scroll
                    const footer = document.querySelector('footer') || document.querySelector('.footer');
                    const footerHeight = footer ? footer.offsetHeight : 100;
                    
                    // Subtract top offset, footer height, and a minimal gap padding 
                    let availableHeight = window.innerHeight - rect.top - footerHeight - 0;
                    
                    this.dynamicHeight = availableHeight > 350 ? availableHeight + 'px' : '350px';
                }
            });
        },
        scrollToTop() {
            const container = document.getElementById('scrollContainer');
            if (container) container.scrollTop = 0;
        },
        toggleNodes(nodes, isExpanded) {
            if (!nodes) return;
            nodes.forEach(node => {
                node.expanded = isExpanded;
                if (node.children && node.children.length > 0) {
                    this.toggleNodes(node.children, isExpanded);
                }
            });
        },
        expandAll() {
            this.toggleNodes(this.localTreeData, true);
        },
        collapseAll() {
            this.toggleNodes(this.localTreeData, false);
        },
        startDragging(e) {
            const container = this.$el.querySelector('.overflow-auto');
            if (!container) return;
            
            this.isDragging = true;
            this.startX = e.pageX - container.offsetLeft;
            this.startY = e.pageY - container.offsetTop;
            this.scrollLeft = container.scrollLeft;
            this.scrollTop = container.scrollTop;
        },
        stopDragging() {
            this.isDragging = false;
        },
        onDragging(e) {
            if (!this.isDragging) return;
            e.preventDefault();
            
            const container = this.$el.querySelector('.overflow-auto');
            if (!container) return;
            
            const x = e.pageX - container.offsetLeft;
            const y = e.pageY - container.offsetTop;
            const walkX = (x - this.startX) * 2; // scroll-fast
            const walkY = (y - this.startY) * 2;
            
            container.scrollLeft = this.scrollLeft - walkX;
            container.scrollTop = this.scrollTop - walkY;
        },
        zoomIn() {
            if (this.zoomLevel < 1.3) {
                this.zoomLevel = Math.round((this.zoomLevel + 0.1) * 10) / 10;
            }
        },
        zoomOut() {
            if (this.zoomLevel > 0.5) {
                this.zoomLevel = Math.round((this.zoomLevel - 0.1) * 10) / 10;
            }
        },
        resetZoom() {
            this.zoomLevel = 1;
        },
        handleWheel(e) {
            // Zoom if Ctrl/Cmd key is pressed OR if we are currently dragging (panning)
            if (e.ctrlKey || e.metaKey || this.isDragging) {
                e.preventDefault();
                if (e.deltaY < 0) {
                    this.zoomIn();
                } else {
                    this.zoomOut();
                }
            }
            // Otherwise, let the browser handle normal scrolling
        },
    }
}
</script>

<style scoped>
/* Scoped css ensures clean fonts globally inherited but scoped logic */
.font-sans {
    font-family: Inter, system-ui, -apple-system, sans-serif;
}

.child-node-row {
    page-break-inside: avoid;
}

/* Tree Transition using Vue's component */
.tree-enter-active,
.tree-leave-active {
    display: grid;
    grid-template-rows: 1fr;
    opacity: 1;
    overflow: hidden;
    transition: grid-template-rows 500ms ease-in-out, opacity 500ms ease-in-out;
}

.tree-enter-from,
.tree-leave-to {
    grid-template-rows: 0fr;
    opacity: 0;
}

.tree-container {
    display: grid; /* Maintain grid structure for children */
}

/* .tree-container.is-root-container {
    margin-top: 1.25rem;
} */

.tree-container-content {
    overflow: hidden;
}

.cursor-grab {
    cursor: grab;
}

.cursor-grabbing {
    cursor: grabbing;
}

.select-none {
    user-select: none;
}
</style>
